import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=6675bc1e&scoped=true&"
import script from "./ContentList.vue?vue&type=script&lang=js&"
export * from "./ContentList.vue?vue&type=script&lang=js&"
import style0 from "./ContentList.vue?vue&type=style&index=0&id=6675bc1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675bc1e",
  null
  
)

export default component.exports